import { MembersService } from 'src/app/services/members.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { MemberPensionService } from 'src/app/services/member-pension.service';
import { BeneficiaryService } from 'src/app/services/beneficiary.service';

@Injectable()
export class MemberPensionEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private router: Router,
    private service: MemberPensionService,
    private beneficiaryService: BeneficiaryService,
  ) {
  }

  getData$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.getPension(action.accountId)),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));

  getBeneficiaryData$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestBeneficiariesAction),
    switchMap((action: any) => this.beneficiaryService.getMemberBeneficiaries(action.accountId)),
    map((data: any) => {
      return ActionsList.ResponseBeneficiariesAction({ payload: data.data });
    })
  ));

}
